import type { ContentPage } from "@/lib/content/types";

export const sms: ContentPage = {
  slug: "omni-channels/sms",
  template: "hrmsFeature",
  seo: {
    title: "CRM SMS - Send & Automate Text Messages | GetBiz CRM",
    description:
      "Send, receive and automate SMS from GetBiz CRM. Reach customers where they read fastest, with texts logged against every contact and triggered by workflows.",
    keywords: [
      "CRM SMS",
      "SMS marketing software",
      "business text messaging",
      "SMS automation",
      "bulk SMS CRM",
      "text message CRM",
    ],
    ogImage: "/assets/data/seoimages/sms.webp",
  },
  leaf: {
    hero: {
      caption: "SMS",
      title: "Reach Customers Where They Reply Fastest",
      description:
        "Send one-to-one and automated SMS from GetBiz CRM, with every message logged to the contact and triggered by your workflows and cadences.",
      h1: "caption",
    },
    split: {
      title: "Texting, Built Into Your CRM",
      bullets: [
        { title: "Two-way SMS", description: "Send and receive texts on the contact record." },
        { title: "Automated Texts", description: "Trigger SMS from workflows and cadences." },
        { title: "Templates", description: "Reusable, personalised message templates." },
        { title: "Delivery Tracking", description: "See what was delivered and replied to." },
      ],
      image: "/assets/images/img/product/crm/sms-lead-image.webp",
      imageAlt: "GetBiz CRM SMS",
    },
    cardsHeading: { title: "More Omni Channels", description: "SMS works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "WhatsApp", href: "/crm-software/omni-channels/whatsapp/", description: "Add WhatsApp to your messaging mix.", image: "/assets/images/img/product/crm/whatsapp.webp", imageAlt: "CRM WhatsApp" },
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Combine SMS with tracked email.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
      { title: "Telephony", href: "/crm-software/omni-channels/telephony/", description: "Call and text from the same record.", image: "/assets/images/img/product/crm/telephony.webp", imageAlt: "CRM telephony" },
      { title: "Live Chat", href: "/crm-software/omni-channels/live-chat/", description: "Convert web visitors, continue by SMS.", image: "/assets/images/img/product/crm/live-chat.webp", imageAlt: "CRM live chat" },
    ],
    testimonials: { title: "Higher reply rates", description: "See why teams text from GetBiz CRM." },
    bookDemoTitle: "Add SMS to your outreach.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sms-marketing-for-sales, business-text-messaging-guide",
    metaKey: "sms",
  },
  sections: [],
};
